<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
  data() {
    return {
      tokenTimer: null,
     
    };
  },
  components: {},
  watch: {
    $route: {
      handler(newVal, oldval) {
        

      },
      deep: true,
    },
  },

  created() {
    
  },
  mounted() {
    
  },
  methods: {

    
   
    
  
  },
};
</script>
<style lang="scss" scoped>
@import "@/style/base.css";
@import "@/style/all.min.css";
html,
body {
  min-height: 100vh;
  width: 100%;
  // min-width: 1080px;
  margin: 0;
  padding: 0;
  user-select: none;
  -webkit-font-smoothing: antialiased; /* Chrome, Safari */
  -moz-osx-font-smoothing: grayscale; /* Firefox */
  text-rendering: optimizeLegibility; /* General */
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  // text-align: center;
  color: #2c3e50;
  margin: 0;
  min-height: 100vh;
  width: 100%;
  transition: all 0.2s linear;
}
</style>
